<template>
    <div>
        <van-tabs v-model="active" @click="rel()">
            <van-tab title="首页" name="indexs">
            </van-tab>
            <van-tab title="分账订单" name="index1">
            </van-tab>
            <van-tab title="分账信息" name="index2">
            </van-tab>
        </van-tabs>
        <div style="padding: 1rem;">
            <div v-if="sure" class="fl1 loads">
                <div class="xql">
                    <van-loading size="26px" color="#fff" type="spinner" vertical>加载中...</van-loading>
                </div>
            </div>
            <div class="account-info">
                <div class="line-height-1-8">账户名称：{{ info.name }}</div>
                <div class="line-height-1-8">账户类型：{{ info.member_type_str }}</div>
                <div class="line-height-1-8">结算方式：T+1 到账</div>
                <div class="line-height-1-8">结算银行卡：{{ info.card_id }}</div>
            </div>
            <div class="transaction-info" v-for="(item, index) in list" :key="index">
                <div class="line-height-1-8 high">{{ item.district_name }}</div>
                <div class="line-height-1-8">
                    <div class="tag" :style="{ color: index2 % 2 != 0 ? '#FC8710' : '' }"
                        v-for="(item2, index2) in item.profit_typename" :key="index2">
                        {{ item2 }}
                    </div>
                </div>
                <div class="line-height-1-8 info-label">
                    <span>分账比例：{{ item.profit_rate }}</span>
                    <img src="../../assets/wen.png" @click="$store.commit('xs', '分账金额为扣除交易费等费用后按比例分账')">
                </div>
                <div class="line-height-1-8">累计分账：<span class="total-amount">{{ item.total_money }}元</span></div>
            </div>
            <img src="../../assets/ww.png" style="width: 100%;" v-if="list.length == 0">
            <p style="text-align: center;color: #999;" v-else>没有数据了</p>
        </div>
    </div>
</template>

<script>
import { getAccdata } from '@/api'
export default {
    components: {},
    data() {
        return {
            sure: true,
            info: '',
            list: [],
            active: 'index2'
        };
    },
    methods: {
        rel() {
            this.$router.push({ path: this.active });
        },
        async get() {
            getAccdata({
                member_id: localStorage.getItem("MemberId"),
                mch_id: localStorage.getItem("MchId"),
                vender_id: localStorage.getItem("VenderId")
            }).then((data) => {
                if (data.code == 1) {
                    this.info = data.data.info;
                    this.list = data.data.list;
                }
            })
            this.sure = false;
        }
    },
    mounted() { this.get(); }
};
</script>
<style lang="less">
.account-info,
.transaction-info {
    background-color: #fff;
    padding: 1rem 1.5rem;
    margin-bottom: 1rem;
    border-radius: .6rem;
}

.line-height-1-8 {
    line-height: 1.8;
}

.high {
    font-weight: bold;
}

.tag {
    color: #409eff;
    margin-right: .8rem;
    display: inline-block;
}

.info-label {
    display: flex;
    align-items: center;
}

.info-label img {
    height: 1.4rem;
    margin-left: .2rem;
    cursor: pointer;
}

.total-amount {
    color: #67c23a;
}
</style>